@if (state.isOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
  (click)="close()">
  <div class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-md"
    (click)="$event.stopPropagation()"
    role="dialog" aria-modal="true">

    <!-- Header -->
    <div class="flex items-start gap-4 p-6 pb-4">
      <div class="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-full bg-orange-100 text-orange-600 dark:bg-orange-500/20 dark:text-orange-400">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
        </svg>
      </div>
      <div class="flex-1 min-w-0 pt-0.5">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Operación de Conjuntos</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Combina miembros de otros segmentos en este</p>
      </div>
    </div>

    <!-- Body -->
    <div class="px-6 pb-2 space-y-4">

      <!-- Tipo de operación -->
      <div>
        <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Tipo de operación</p>
        <div class="grid grid-cols-3 gap-2">
          @for (op of opTypes; track op.value) {
          <button type="button" (click)="onOpTypeChange(op.value)"
            [class.bg-orange-500]="setOpType === op.value"
            [class.text-white]="setOpType === op.value"
            [class.border-orange-500]="setOpType === op.value"
            [class.bg-white]="setOpType !== op.value"
            [class.dark:bg-gray-800]="setOpType !== op.value"
            [class.text-gray-700]="setOpType !== op.value"
            [class.dark:text-gray-300]="setOpType !== op.value"
            [class.border-gray-300]="setOpType !== op.value"
            [class.dark:border-gray-600]="setOpType !== op.value"
            [class.hover:bg-gray-50]="setOpType !== op.value"
            [class.dark:hover:bg-gray-700]="setOpType !== op.value"
            class="px-3 py-2.5 text-sm font-medium rounded-lg border transition-colors text-center">
            <span class="block text-xs font-bold">{{ op.label }}</span>
            <span class="block text-[10px] mt-0.5 opacity-70">{{ op.sub }}</span>
          </button>
          }
        </div>
      </div>

      <!-- UNIÓN / INTERSECCIÓN: lista simple de checkboxes -->
      @if (setOpType !== 'DIFFERENCE') {
      <div>
        @if (setOpType === 'UNION') {
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Combina todos los miembros de los segmentos seleccionados <span class="font-semibold text-gray-700 dark:text-gray-300">sin duplicados</span>. Un contacto aparece en el resultado si está en <span class="font-semibold text-gray-700 dark:text-gray-300">cualquiera</span> de los segmentos fuente.
        </p>
        } @else {
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Solo incluye los miembros presentes en <span class="font-semibold text-gray-700 dark:text-gray-300">todos</span> los segmentos seleccionados. Un contacto aparece en el resultado únicamente si está en <span class="font-semibold text-gray-700 dark:text-gray-300">cada uno</span> de los segmentos fuente.
        </p>
        }
        <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Segmentos fuente</p>
        <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden max-h-44 overflow-y-auto custom-scrollbar">
          @if (isLoadingSegments) {
            <div class="flex items-center justify-center py-6">
              <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-orange-500"></div>
            </div>
          } @else if (availableSegments.length === 0) {
            <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-5">No hay otros segmentos disponibles</p>
          } @else {
            @for (seg of availableSegments; track seg.id) {
            <button type="button" (click)="toggleSource(seg.id)"
              class="w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0"
              [class.bg-orange-50]="isSelected(seg.id)"
              [class.dark:bg-orange-900/10]="isSelected(seg.id)"
              [class.hover:bg-gray-50]="!isSelected(seg.id)"
              [class.dark:hover:bg-gray-800]="!isSelected(seg.id)">
              <div class="w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                [class.bg-orange-500]="isSelected(seg.id)"
                [class.border-orange-500]="isSelected(seg.id)"
                [class.border-gray-300]="!isSelected(seg.id)"
                [class.dark:border-gray-600]="!isSelected(seg.id)">
                @if (isSelected(seg.id)) {
                  <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                  </svg>
                }
              </div>
              <div class="min-w-0 flex-1">
                <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
                <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
              </div>
            </button>
            }
          }
        </div>
      </div>
      }

      <!-- DIFERENCIA: dos zonas A y B -->
      @if (setOpType === 'DIFFERENCE') {
      <div class="space-y-3">
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Selecciona un segmento base <span class="font-semibold text-gray-700 dark:text-gray-300">A</span> y uno o más segmentos a restar <span class="font-semibold text-gray-700 dark:text-gray-300">B</span>. El resultado serán los miembros de A que no estén en B.
        </p>

        <!-- Zona A: base (radio) -->
        <div>
          <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">
            Base (A)
            <span class="ml-1 normal-case font-normal">— un solo segmento</span>
          </p>
          <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden max-h-36 overflow-y-auto custom-scrollbar">
            @if (isLoadingSegments) {
              <div class="flex items-center justify-center py-4">
                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-orange-500"></div>
              </div>
            } @else if (availableSegments.length === 0) {
              <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">No hay segmentos disponibles</p>
            } @else {
              @for (seg of availableSegments; track seg.id) {
              <button type="button" (click)="toggleBase(seg.id)"
                class="w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0"
                [class.bg-orange-50]="baseSegmentId === seg.id"
                [class.dark:bg-orange-900/10]="baseSegmentId === seg.id"
                [class.hover:bg-gray-50]="baseSegmentId !== seg.id"
                [class.dark:hover:bg-gray-800]="baseSegmentId !== seg.id">
                <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors"
                  [class.bg-orange-500]="baseSegmentId === seg.id"
                  [class.border-orange-500]="baseSegmentId === seg.id"
                  [class.border-gray-300]="baseSegmentId !== seg.id"
                  [class.dark:border-gray-600]="baseSegmentId !== seg.id">
                  @if (baseSegmentId === seg.id) {
                    <div class="w-1.5 h-1.5 rounded-full bg-white"></div>
                  }
                </div>
                <div class="min-w-0 flex-1">
                  <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
                  <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
                </div>
              </button>
              }
            }
          </div>
        </div>

        <!-- Zona B: restar (checkboxes, excluye el base) -->
        <div>
          <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">
            Restar (B)
            <span class="ml-1 normal-case font-normal">— uno o más segmentos</span>
          </p>
          <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden max-h-36 overflow-y-auto custom-scrollbar">
            @if (isLoadingSegments) {
              <div class="flex items-center justify-center py-4">
                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-orange-500"></div>
              </div>
            } @else if (availableSegments.length === 0) {
              <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">No hay segmentos disponibles</p>
            } @else {
              @for (seg of availableSegments; track seg.id) {
              <button type="button" (click)="toggleSubtract(seg.id)"
                [disabled]="seg.id === baseSegmentId"
                class="w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0 disabled:opacity-40 disabled:cursor-not-allowed"
                [class.bg-orange-50]="subtractIds.includes(seg.id)"
                [class.dark:bg-orange-900/10]="subtractIds.includes(seg.id)"
                [class.hover:bg-gray-50]="!subtractIds.includes(seg.id) && seg.id !== baseSegmentId"
                [class.dark:hover:bg-gray-800]="!subtractIds.includes(seg.id) && seg.id !== baseSegmentId">
                <div class="w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                  [class.bg-orange-500]="subtractIds.includes(seg.id)"
                  [class.border-orange-500]="subtractIds.includes(seg.id)"
                  [class.border-gray-300]="!subtractIds.includes(seg.id)"
                  [class.dark:border-gray-600]="!subtractIds.includes(seg.id)">
                  @if (subtractIds.includes(seg.id)) {
                    <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                    </svg>
                  }
                </div>
                <div class="min-w-0 flex-1">
                  <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
                  <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
                </div>
              </button>
              }
            }
          </div>
        </div>
      </div>
      }

    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-2 p-6 pt-4">
      <button type="button" (click)="close()"
        class="px-4 py-2 text-sm font-medium rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button type="button" (click)="ejecutar()" [disabled]="isExecuting || !canExecute"
        class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md text-white bg-orange-500 hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        @if (isExecuting) {
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        }
        Ejecutar
      </button>
    </div>

  </div>
</div>
}
